import app from 'flarum/forum/app';
import { extend } from 'flarum/common/extend';
import Button from 'flarum/common/components/Button';
import PostControls from 'flarum/forum/utils/PostControls';
import DiscussionPage from 'flarum/forum/components/DiscussionPage';
import CommentPost from 'flarum/forum/components/CommentPost';
import extractText from 'flarum/common/utils/extractText';
export default function addBestAnswerAction() {
  const ineligible = (discussion, post) => {
    return post.isHidden() || post.number() === 1 || !post.canSelectAsBestAnswer() || !app.session.user;
  };
  const isThisBestAnswer = (discussion, post) => {
    var _discussion$bestAnswe, _bAPost$id;
    const bAPost = (_discussion$bestAnswe = discussion.bestAnswerPost) == null ? void 0 : _discussion$bestAnswe.call(discussion);
    const hasBestAnswer = discussion.hasBestAnswer();
    return hasBestAnswer !== undefined && hasBestAnswer && !!bAPost && ((_bAPost$id = bAPost.id) == null ? void 0 : _bAPost$id.call(bAPost)) === post.id();
  };
  const actionLabel = isBestAnswer => {
    return extractText(app.translator.trans(isBestAnswer ? 'fof-best-answer.forum.remove_best_answer' : 'fof-best-answer.forum.this_best_answer'));
  };
  const saveDiscussion = (discussion, isBestAnswer, post) => discussion.save({
    relationships: {
      // @ts-expect-error
      bestAnswerPost: isBestAnswer ? post : {
        data: null
      }
    }
  }, {
    params: {
      include: 'tags'
    }
  }).then(() => {
    if (!isBestAnswer) {
      if (discussion.data.relationships) {
        delete discussion.data.relationships.bestAnswerPost;
        delete discussion.data.relationships.bestAnswerUser;
      }
    }
    if (app.current.matches(DiscussionPage)) {
      app.current.get('stream').update();
    }
    m.redraw();
    if (isBestAnswer) {
      m.route.set(app.route.discussion(discussion));
    }
  });
  extend(PostControls, 'moderationControls', function (items, post) {
    if (app.forum.attribute('useAlternativeBestAnswerUi')) return;
    const discussion = post.discussion();
    let isBestAnswer = isThisBestAnswer(discussion, post);
    post.pushAttributes({
      isBestAnswer
    });
    if (post.contentType() !== 'comment') return;
    if (ineligible(discussion, post) || !app.current.matches(DiscussionPage)) return;
    items.add('bestAnswer', m(Button, {
      icon: "fa".concat(isBestAnswer ? 's' : 'r', " fa-comment-dots"),
      onclick: () => {
        isBestAnswer = !isBestAnswer;
        saveDiscussion(discussion, isBestAnswer, post).finally(() => {
          isBestAnswer = isThisBestAnswer(discussion, post);
        });
      }
    }, actionLabel(isBestAnswer)));
  });
  extend(CommentPost.prototype, 'actionItems', function (items) {
    if (!app.forum.attribute('useAlternativeBestAnswerUi')) return;
    const post = this.attrs.post;
    const discussion = this.attrs.post.discussion();
    let isBestAnswer = isThisBestAnswer(discussion, post);
    let hasBestAnswer = discussion.bestAnswerPost() !== null;
    post.pushAttributes({
      isBestAnswer
    });
    if (ineligible(discussion, post) || !app.current.matches(DiscussionPage)) return;
    items.add('bestAnswer', m(Button, {
      className: "Button Button--".concat(!hasBestAnswer || isBestAnswer ? 'primary' : 'link'),
      onclick: () => {
        hasBestAnswer = !hasBestAnswer;
        isBestAnswer = !isBestAnswer;
        saveDiscussion(discussion, isBestAnswer, post).finally(() => {
          hasBestAnswer = !!discussion.hasBestAnswer() && discussion.bestAnswerPost() !== null;
          isBestAnswer = isThisBestAnswer(discussion, post);
        });
      }
    }, actionLabel(isBestAnswer)));
  });
}